import { Selection, BaseType } from 'd3';
import { TDrawModel } from '../../draw.model';
import { TEntityGroups } from '../../timeline.types';

export type TEntityGroupSelection = Selection<
  BaseType | SVGGElement | SVGSVGElement,
  TEntityGroups<unknown, unknown, unknown>,
  BaseType,
  TDrawModel
>;

type OverlayTarget = {
  selection: TEntityGroupSelection;
  className: 'entity-disabled-overlay' | 'left-nav-disabled-overlay';
};

const drawDisabledEntityOverlays = (targets: OverlayTarget[], drawModel: TDrawModel, validRowIds: string[] | null) => {
  const isDisabled = (row: TEntityGroups['entities'][number]) =>
    validRowIds !== null && row.isStripDropTarget !== false && !validRowIds.includes(row.id);

  targets.forEach(({ selection, className }) => {
    selection
      .selectAll(`.${className}`)
      .data((d) => d.entities)
      .join('rect')
      .classed(className, true)
      .attr('x', 0)
      .attr('y', (_, i) => drawModel.layout.entityHeight * i)
      .attr('width', '100%')
      .attr('height', drawModel.layout.entityHeight)
      .attr('fill', 'rgba(128, 128, 128, 0.2)')
      .style('pointer-events', 'none')
      .attr('display', (d) => (isDisabled(d) ? null : 'none'));
  });
};

export const DRAW_OVERLAYS = { drawDisabledEntityOverlays };
